export default {
  blackLists: (state) => {
    return state.blackLists;
  },

  saleManagerDiscountLimits: (state) => {
    return state.saleManagerDiscountLimits;
  },

  saleManagerCredits: (state) => {
    return state.saleManagerCredits;
  },

  ordrSettings: (state) => {
    return state.ordrSettings;
  },

  orders: (state) => {
    return state.orders;
  },
  orderById: (state) => {
    return state.orderById;
  },
  orderMaxCode: (state) => {
    return state.orderMaxCode;
  },

  orderCartable: (state) => {
    return state.orderCartable;
  },

  orderManagementCartable: (state) => {
    return state.orderManagementCartable;
  },

  orderPermitCartable: (state) => {
    return state.orderPermitCartable;
  },
  orderPermits: (state) => {
    return state.orderPermits;
  },

  orderDraftCartable: (state) => {
    return state.orderDraftCartable;
  },
  orderDrafts: (state) => {
    return state.orderDrafts;
  },

  settlementTypes: (state) => {
    return state.settlementTypes;
  },
  settlementTypeCode: (state) => {
    return state.settlementTypeCode;
  },

  printLink: (state) => {
    return state.printLink;
  },
};
